import React from 'react';
import { IconAlert } from '@americanexpress/dls-react';
import LiteralsService from 'src/services/literals/LiteralsService';
import { goToReviewTransactions } from 'src/services/router.service';
import Banner from 'src/components/banner/Banner';
import { useHistory, useLocation } from 'react-router-dom';
import adobeTags from 'src/types/adobe-tags';
import Selectors from 'src/utils/selectors';
import { useReviewableTransactions } from 'src/hooks/queries/transactions';
import { BudgetPages } from 'src/components/atomic/pages/BudgetPages';

const pagesToShowBanner: BudgetPages[] = [BudgetPages.HOME, BudgetPages.HISTORY, BudgetPages.TRANSACTIONS];

export default function ReviewTransactionsBanner(): JSX.Element {
    const history = useHistory();
    const { pathname } = useLocation();
    const enabled: boolean = pagesToShowBanner.includes(pathname);
    const { data: reviewableTransactions } = useReviewableTransactions({ enabled });
    const numTransactionsToReview: number = reviewableTransactions?.totalLength;

    if (!enabled || !numTransactionsToReview) return null;

    return (
        <Banner
            icon={<IconAlert filled />}
            data-cy={Selectors.Transactions.NO_OF_REVIEW_TRANSACTIONS}
            text={LiteralsService.getLiteral('TransactionsView.review.banner.transactionsNeedReview', [
                numTransactionsToReview
            ])}
            linkText={LiteralsService.getLiteral('TransactionsView.review.reviewTransactions', [
                numTransactionsToReview
            ])}
            onLinkClick={() => goToReviewTransactions(false, history)}
            href={BudgetPages.TRANSACTIONS_REVIEW}
            linkDescription={LiteralsService.getLiteral('TransactionsView.review.banner.linkDescription')}
            tag={adobeTags.Banner.ReviewTransactions}
        />
    );
}
